// extracted by extract-css-chunks-webpack-plugin
module.exports = {"back-to-giving-statements":"send-statements-page__back-to-giving-statements___3QN-W","backToGivingStatements":"send-statements-page__back-to-giving-statements___3QN-W","spacing":"send-statements-page__spacing___1ytzw","separator":"send-statements-page__separator___3h4vn"};
    if(module.hot) {
      // 1750042749282
      var cssReload = require("../../../../../node_modules/extract-css-chunks-webpack-plugin/dist/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModules":true});
      module.hot.dispose(cssReload);
      ;
    }
  